export default "__VITE_ASSET__DiskMdb6__"